// Returns a resolved route for a vacancy. It's resolved because that way a different layer (meedoen) can resolve
// it with other context, like the current desk.
export default function useVacancyDetailRoute(vacancy: Partial<BaseVacancy>) {
  if (!vacancy?.id) return undefined

  const localePath = useLocalePath()

  // const router = useRouter()
  const vacancyDetailRouteName = 'vacancies-id'

  // Construct the RouteLocationRaw object with the appropriate params
  const routeLocation = {
    name: vacancyDetailRouteName,
    params: { id: vacancy.id || '#' },
  }

  // Resolve the route (// router.resolve)
  return localePath(routeLocation)
}
